import Vue from "vue";
import Vuex from "vuex";
import user from "./user";
import createPersistedState from 'vuex-persistedstate';
 
Vue.use(Vuex);
 
const store = new Vuex.Store({
  modules: {
    user
  },
  plugins: [createPersistedState(
    { // ストレージのキーを指定。デフォルトではvuex
      key: 'anyGreatApp',

      // 管理対象のステートを指定。pathsを書かない時は`modules`に書いたモジュールに含まれるステート全て。`[]`の時はどれも保存されない
      // paths: [
      //   'user'
      // ],

      // ストレージの種類を指定する。デフォルトではローカルストレージ
      storage: window.sessionStorage
    }
  )]
});
 
export default store;